module.exports = __webpack_public_path__ + "img/8.31229af1.jpg";